/**
 * 应用常量定义
 */
export default {
  // 作品状态
  WORK_STATUS: {
    DRAFT: { value: 'draft', label: '草稿', color: 'info', tag: '草稿' },
    PENDING: { value: 'pending', label: '待审核', color: 'warning', tag: '待审核' },
    PUBLISHED: { value: 'published', label: '已发布', color: 'success', tag: '已发布' },
    OFFLINE: { value: 'offline', label: '已下架', color: 'danger', tag: '已下架' },
    REJECTED: { value: 'rejected', label: '已驳回', color: 'danger', tag: '已驳回' }
  },

  // 收益类型
  EARNING_TYPE: {
    AD: { value: 'ad', label: '广告收益', color: 'primary' },
    PAY: { value: 'pay', label: '付费解锁', color: 'success' },
    REWARD: { value: 'reward', label: '打赏收益', color: 'warning' },
    SUBSIDY: { value: 'subsidy', label: '平台补贴', color: 'info' }
  },

  // 收益状态
  EARNING_STATUS: {
    SETTLED: { value: 'settled', label: '已结算', color: 'success' },
    PENDING: { value: 'pending', label: '待结算', color: 'warning' },
    PROCESSING: { value: 'processing', label: '结算中', color: 'info' },
    FAILED: { value: 'failed', label: '结算失败', color: 'danger' }
  },

  // 提现状态
  WITHDRAW_STATUS: {
    SUCCESS: { value: 'success', label: '提现成功', color: 'success' },
    PROCESSING: { value: 'processing', label: '处理中', color: 'warning' },
    FAILED: { value: 'failed', label: '提现失败', color: 'danger' },
    CANCELLED: { value: 'cancelled', label: '已取消', color: 'info' }
  },

  // 消息类型
  MESSAGE_TYPE: {
    SYSTEM: { value: 'system', label: '系统通知', icon: 'el-icon-info', color: '#409EFF' },
    COMMENT: { value: 'comment', label: '评论回复', icon: 'el-icon-chat-dot-round', color: '#67C23A' },
    LIKE: { value: 'like', label: '点赞通知', icon: 'el-icon-star-on', color: '#E6A23C' },
    WITHDRAW: { value: 'withdraw', label: '提现通知', icon: 'el-icon-bank-card', color: '#F56C6C' },
    WORK: { value: 'work', label: '作品动态', icon: 'el-icon-document', color: '#909399' }
  },

  // 作品分类
  WORK_CATEGORIES: [
    { value: 'sci-fi', label: '科幻', icon: '🚀' },
    { value: 'fantasy', label: '奇幻', icon: '🧙' },
    { value: 'martial', label: '武侠', icon: '⚔️' },
    { value: 'school', label: '校园', icon: '🏫' },
    { value: 'comedy', label: '搞笑', icon: '😄' },
    { value: 'adventure', label: '冒险', icon: '🏔️' },
    { value: 'romance', label: '恋爱', icon: '❤️' },
    { value: 'horror', label: '恐怖', icon: '👻' }
  ],

  // 作品标签
  WORK_TAGS: [
    '热血', '搞笑', '校园', '奇幻', '科幻', '动作', 
    '古风', '武侠', '恋爱', '冒险', '悬疑', '治愈'
  ],

  // 解锁方式
  UNLOCK_TYPES: {
    FREE: { value: 'free', label: '免费', icon: '🎁' },
    AD: { value: 'ad', label: '广告解锁', icon: '📺' },
    COIN: { value: 'coin', label: '金币解锁', icon: '💰' },
    VIP: { value: 'vip', label: 'VIP免费', icon: '👑' }
  },

  // 时间范围
  TIME_RANGES: [
    { value: 'today', label: '今日' },
    { value: 'yesterday', label: '昨日' },
    { value: 'week', label: '本周' },
    { value: 'month', label: '本月' },
    { value: 'quarter', label: '本季' },
    { value: 'year', label: '全年' },
    { value: 'custom', label: '自定义' }
  ],

  // 图表颜色
  CHART_COLORS: [
    '#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399',
    '#9B59B6', '#3498DB', '#E91E63', '#00BCD4', '#FF9800'
  ],

  // 页码大小选项
  PAGE_SIZES: [10, 20, 30, 40, 50, 100],

  // 默认分页
  DEFAULT_PAGE: {
    page: 1,
    limit: 10
  },

  // 日期格式
  DATE_FORMAT: {
    DATE: 'YYYY-MM-DD',
    TIME: 'HH:mm:ss',
    DATETIME: 'YYYY-MM-DD HH:mm:ss',
    MONTH: 'YYYY-MM',
    YEAR: 'YYYY'
  },

  // 上传文件限制
  UPLOAD_LIMIT: {
    IMAGE: {
      maxSize: 5, // MB
      types: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
      maxCount: 9
    },
    VIDEO: {
      maxSize: 50, // MB
      types: ['video/mp4', 'video/webm', 'video/ogg'],
      maxCount: 1
    },
    FILE: {
      maxSize: 20, // MB
      types: ['application/pdf', 'application/msword', 'text/plain'],
      maxCount: 5
    }
  }
}